export default {
  defaultCurrency: 'KRW'
}